import { ScreenHint } from '@oneclick/types/auth';

export const getScreenHintParam = (): string => {
  const urlParams = new URLSearchParams(window.location.search);
  const screenHintQuery = urlParams.get('screen_hint');
  let screenHint = '';
  if (
    screenHintQuery &&
    Object.values(ScreenHint).includes(screenHintQuery as ScreenHint)
  ) {
    screenHint = screenHintQuery;
  }
  return screenHint;
};
